import { takeEvery, put, select } from 'redux-saga/effects';
import { addDepToPeriodRoutine, removeDepFromPeriodRoutine } from './routines';
import { patientSelector } from '../Patients/selectors';
import { putPatientRoutine } from '../Patients/routines';

function* handleAddDepToPeriod({ payload }) {
  const { patientId, periodId, depId } = payload;

  const patient = yield select(patientSelector, patientId);
  if (!patient || !patient.timeline) return;

  const newTimeline = patient.timeline.map(period =>
    period.id === periodId
      ? { ...period, depIds: [...(period.depIds || []), depId] }
      : period
  );

  yield put(putPatientRoutine.trigger({
    id: patientId,
    values: { timeline: newTimeline },
  }));
}

function* handleRemoveDepFromPeriod({ payload }) {
  const { patientId, periodId, depId } = payload;

  const patient = yield select(patientSelector, patientId);
  if (!patient || !patient.timeline) return;

  const newTimeline = patient.timeline.map(period =>
    period.id === periodId
      ? { ...period, depIds: (period.depIds || []).filter(id => id !== depId) }
      : period
  );

  yield put(putPatientRoutine.trigger({
    id: patientId,
    values: { timeline: newTimeline },
  }));
}

export function* watchTimelineDeps() {
  // yield takeEvery(addDepToPeriodRoutine.TRIGGER, handleAddDepToPeriod);
  // yield takeEvery(removeDepFromPeriodRoutine.TRIGGER, handleRemoveDepFromPeriod);
}
